module.exports = __webpack_public_path__ + "img/receipt-pdf-white.9a81592b.svg";